/*
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from '@app/core/services';
import { CoreFacade } from '@app/store/core/core.facade';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Component({
  template: `<div>{{ error }}</div>`,
})
export class OktaCallbackComponent implements OnInit {
  error: string;

  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private router: Router,
    private coreFacade: CoreFacade,
    private logger: Logger
  ) {}

  async ngOnInit() {
    /**
     * Handles the response from Okta and parses tokens.
     */
    this.coreFacade.toggleLoader(true);
    return this.oktaAuth
      .handleLoginRedirect()
      .then(() => {
        /**
         * Navigate back to the saved uri, or root of application.
         */
        const fromUri = this.oktaAuth.getOriginalUri();
        const path = fromUri ? new URL(fromUri)?.pathname : '/';
        this.router.navigateByUrl(path);
      })
      .catch((error: Error) => {
        this.coreFacade.toggleLoader(false);
        this.logger.error(error);
        this.router.navigateByUrl('/');
      });
  }
}
